export default {
  us: {
    price: {
      value: 73,
      code: 'USD',
      symbol: '$',
    },
  },
  au: {
    price: {
      value: 157,
      code: 'AUD',
      symbol: '$',
    },
  },
  gb: {
    price: {
      value: 62,
      code: 'GBP',
      symbol: '£',
    },
  },
};
